/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_Blocked_Support_TitleInputs */

const en_premium_blocked_support_title = /** @type {(inputs: Premium_Blocked_Support_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your subscription needs a hand`)
};

const es_premium_blocked_support_title = /** @type {(inputs: Premium_Blocked_Support_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu suscripción necesita ayuda`)
};

/**
* | output |
* | --- |
* | "Your subscription needs a hand" |
*
* @param {Premium_Blocked_Support_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const premium_blocked_support_title = /** @type {((inputs?: Premium_Blocked_Support_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Blocked_Support_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_premium_blocked_support_title(inputs)
	return en_premium_blocked_support_title(inputs)
});